import React from "react";
import MainContent from "../../../../widgets/templates/main_content";
import { Link } from "react-router-dom";
import { path_modules } from "../../../app_modules";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useAcademicConceptCreateEdit } from "../../../../_hooks/academic_concept/useAcademicConceptCreateEdit.hook";
import ObjectSelect from "../../../../widgets/select/object_select";
import { useAcademicPartAll } from "../../../../_hooks/academic_part/useAcademicPartAll.hook";
import { alertError } from "../../../../_utils/alerts";
import { useAllSemester } from "../../../../_hooks/semester/useAllSemester.hook";

function AcademicConceptsForm(){

    const creationHook = useAcademicConceptCreateEdit();

    const academicParts = useAcademicPartAll();
    const semesters = useAllSemester();

    return(
        <MainContent>
            <div className="flex-row" style={{ marginTop: '15px' }}>
                <div style={{ width: '100%' }}>
                    <Link style={{ marginRight: '30px', width: '100%' }} to={path_modules.content.children.parametrization.children.academic_concepts.fullPath}>
                        <svg width={20} height={20} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--emojione-monotone" preserveAspectRatio="xMidYMid meet" fill="#074C00" stroke="#074C00"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M32 2C15.432 2 2 15.432 2 32s13.432 30 30 30s30-13.432 30-30S48.568 2 32 2zm6 50L18 32l20-20v40z" fill="#074C00"></path></g></svg>
                    </Link>
                    <span className="vp-title">Concepto académico</span>
                </div>
            </div>
            <hr />
            <div style={{ width: '100%' }}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <div className='form-label'>Nombre</div>
                            <input 
                                className='vp-input' 
                                type='text'
                                value={ creationHook.entity?.name }
                                onChange={(e) => {
                                    let newEnt = {...creationHook.entity};
                                    newEnt.name = e.target.value;
                                    creationHook.setEntity(newEnt);
                                }}
                            />
                            <div className='form-label'>Total puntos</div>
                            <input 
                                className='vp-input' 
                                type='number'
                                value={ creationHook.entity?.total_points }
                                onChange={(e) => {
                                    let newEnt = {...creationHook.entity};
                                    try{
                                        newEnt.total_points = e.target.value !== '' ? Number(e.target.value) : e.target.value;
                                    } catch (e){
                                        alertError('No es un número válido');
                                    }                                    
                                    creationHook.setEntity(newEnt);
                                }}
                            />
                            <div style={{ fontSize: '0.7em', fontStyle: 'italic' }}>Si el puntaje es 1, no se mostrará en la tabal de calificaciones</div>
                        </Col>
                        <Col lg={6}>                            
                            <Row>
                            <Col lg={6}>
                                <div className='form-label'>Parte académica</div>
                                <ObjectSelect
                                    value={creationHook.entity?.part}
                                    options={academicParts.data.map( d => ({ value: d.cod, label: d.name }))}
                                    onChange={(e) => {
                                        let newEnt = {...creationHook.entity};
                                        newEnt.part = e;
                                        creationHook.setEntity(newEnt);
                                    }}
                                />
                            </Col>
                            <Col lg={6}>
                                <div className='form-label'>Semestre</div>
                                <ObjectSelect
                                    value={creationHook.entity?.semester}
                                    options={semesters.data.map( d => ({ value: d.cod, label: d.name }))}
                                    onChange={(e) => {
                                        let newEnt = {...creationHook.entity};
                                        newEnt.semester = e;
                                        creationHook.setEntity(newEnt);
                                    }}
                                />
                            </Col>
                            <Col lg={12}>
                                <div className='form-label'>Color representativo</div>
                                <input
                                    type="color"
                                    value={creationHook.entity?.color_id}
                                    onChange={(e) => {
                                        let newEnt = {...creationHook.entity};
                                        console.log(e.target);
                                        newEnt.color_id = e.target.value;
                                        creationHook.setEntity(newEnt);
                                    }}
                                />
                            </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={4}></Col>
                        <Col lg={4}>
                            <Button onClick={ creationHook.uuid ? () => creationHook.edit() : () => creationHook.create() } variant="success" size="sm" style={{ width: '100%', margin: '20px 0px' }}>
                                { creationHook.uuid ? 'Editar' : 'Crear' }
                            </Button>
                        </Col>
                        <Col lg={4}></Col>
                    </Row>
                </Container>
            </div>
        </MainContent>
    );
}

export default AcademicConceptsForm;